import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {
  ISimpleSelectableData,
  ISimpleSelectableDataList
} from '../model/interface/simple-selectable-data.model.interface';
import {ContractItemService} from '../../core/services/contract-item.service';
import {map} from 'rxjs/operators';
import {ContractItemTypeHelper} from '../helper/contract-item-type.helper';
import {ContractService} from "../../core/services/contract.service";
import {ContractTypeHelper} from "../helper/contract-type.helper";
import {IStatusEntry} from "../model/interface/contract-status.model.interface";
import {DepartmentService} from "../../core/services/department.service";


@Component({
  selector: 'app-legal-case-searcher-view',
  templateUrl: './legal-case-searcher-view.component.html',
  styleUrls: ['./legal-case-searcher-view.component.css']
})
export class LegalCaseSearcherViewComponent implements OnInit {
  @Input() title;
  searchFormGroup: FormGroup;
  contractItemTypes: ISimpleSelectableDataList;
  departments: ISimpleSelectableDataList;
  contractTypes: ISimpleSelectableDataList;
  contractInvoiceStatuses: ISimpleSelectableDataList;
  contractIncasoStatuses: ISimpleSelectableDataList;
  contractProceedingStatuses: ISimpleSelectableDataList;
  contractItemStatuses: ISimpleSelectableDataList;

  constructor(private formBuilder: FormBuilder,
              private contractService: ContractService,
              private contractItemService: ContractItemService,
              private departmentService: DepartmentService) {
    this.createForm();
  }

  ngOnInit(): void {
    this.fetchContractItemTypes();
    this.fetchContractTypes();
    this.fetchContractInvoice();
    this.fetchContractIncaso();
    this.fetchContractProceeding();
    this.fetchContractItemStatus();
    this.fetchDepartments();
  }

  private createForm() {
    this.searchFormGroup = this.formBuilder.group({
      onlyOnGoing: false,
      briefcaseNumber: null,
      oldBriefcaseNumber: null,
      stateId: null,
      coreCreatedAt: null,
      createdAt: null,
      endAt: null,
      departmentId: null,
      vindicatorId: null,
      fieldAttorneyId: null,
      contractNumber: null,
      instructingId: null,
      instructingGroupId: null,
      providerId: null,
      applicantId: null,
      debtorCoreId: null,
      legalCaseDescription: null,
      debtorNIP: null,
      supervisorId: null,
      contractItem: null,
      contractItemTypeId: null,
      contractTypeId: null,
      transitionalParkingLotAt: null,
      targetParkingLotAt: null,
      debtorNumber: null,
      postingNumber: null,
      phone: null,
      email: null,
      postalCode: null,
      initialBalance: null,
      balance: null,
      lastPaymentAt: null,
      lastPaymentAmount: null,
      externalContractId: null,
      incasoStatusId: null,
      invoiceStatusId: null,
      proceedingStatusId: null,
      contractItemStatusId: null
    });
  }

  private fetchContractItemTypes() {
    const request = this.createFetchContractItemTypesRequest();
    request.subscribe(
      (itemTypes) => this.contractItemTypes = itemTypes
    );
  }

  private createFetchContractItemTypesRequest() {
    return this.contractItemService.getAllAvailableContractItemTypes()
      .pipe(
        map((itemTypes) => ContractItemTypeHelper.fromListToSelectableList(itemTypes))
      );
  }

  private fetchContractTypes() {
    const request = this.createFetchContractTypesRequest();
    request.subscribe(
        (contractTypes) => this.contractTypes = contractTypes
    );
  }

  private createFetchContractTypesRequest() {
    return this.contractService.getContractTypes()
        .pipe(
            map((itemTypes) => ContractTypeHelper.fromListToSelectableList(itemTypes))
        );
  }

  private fetchContractInvoice() {
    this.contractService.getContractInvoiceStatuses().subscribe(
        (statuses: IStatusEntry[]) => {
          this.contractInvoiceStatuses = LegalCaseSearcherViewComponent._map(statuses);
        }
    );
  }

  private fetchContractIncaso() {
    this.contractService.getContractIncasoStatuses().subscribe(
        (statuses: IStatusEntry[]) =>  {
          this.contractIncasoStatuses = LegalCaseSearcherViewComponent._map(statuses);
    });
  }

  private fetchContractProceeding() {
    this.contractService.getContractProceedingStatuses().subscribe(
        (statuses: IStatusEntry[]) =>  {
          this.contractProceedingStatuses = LegalCaseSearcherViewComponent._map(statuses);
        }
    );
  }

  private fetchContractItemStatus() {
    this.contractItemService.getAllAvailableContractItemStatuses()
        .pipe(
            map(LegalCaseSearcherViewComponent._map)
        )
        .subscribe(
        (statuses) =>  {
          this.contractItemStatuses = statuses;
        }
    );
  }

  private static _map(statuses: IStatusEntry[]) {
    const data: ISimpleSelectableData[] = statuses.map(item => ({
      label: item.label,
      value: item.id,
    }))

    return {
      data,
      totalCount: data.length
    }
  }

  private fetchDepartments() {
    this.departmentService.getAll().pipe(
        map(data => data.toSimpleSelectableDataList())
    ).subscribe(data => this.departments = data);
  }
}
